import axios from 'axios'

const service = axios.create({
  baseURL: 'https://xl.e-odc.com/', 
  timeout: 5000 
})
service.interceptors.request.use(
  config => {
    if(localStorage.getItem('accessToken')){
      config.headers['accessToken'] = localStorage.getItem('accessToken');
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)
export default service
